import { FC } from 'react'
import { Text, TextProps } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

const Label: FC<TextProps> = ({ children, style, ...props }) => {
    const { styles } = useStyles(stylesheet)

    return (
        <Text {...props} style={[styles.label, style]}>
            {children}
        </Text>
    )
}

const stylesheet = createStyleSheet((theme) => ({
    label: {
        fontFamily: theme.fonts.medium,
        fontSize: 12,
    },
}))

export default Label
